<template>
  <a-row :gutter="24" id="company">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false" :visible="visible">
        <a-form :form="form" id="userModal">
          <div class="title-info" >基本信息</div>

          <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input :disabled="isDetail" placeholder="请输入公司名称" v-decorator.trim="['companyName', validatorRules.companyName]" />
          </a-form-item>
          <a-form-item label="统一社会信息用代码" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input :disabled="isDetail" placeholder="请输入统一社会信息用代码" v-decorator.trim="['socialCode', validatorRules.socialCode]" />
          </a-form-item>
          <a-form-item label="联系地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input :disabled="isDetail" placeholder="请输入联系地址" v-decorator.trim="['companyAddress', validatorRules.companyAddress]" />
          </a-form-item>
          <a-form-item label="联系电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input :disabled="isDetail" placeholder="请输入联系电话" v-decorator.trim="['companyFax', validatorRules.companyTel]" />
          </a-form-item>
          <a-form-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input :disabled="isDetail" placeholder="请输入负责人" v-decorator.trim="['companyContacts']" />
          </a-form-item>
          <a-form-item label="负责人电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input :disabled="isDetail" placeholder="请输入负责人电话" v-decorator.trim="['companyTel']" />
          </a-form-item>

          <div class="title-info" >标识信息</div>
          <a-form-item label="企业标识码码制" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-right: 40%">
            <a-checkbox-group :disabled="isDetail" v-decorator.trim="['nodeType', validatorRules.nodeType]"  @change="onColChange">
              <a-checkbox :value="item.value" v-for="item in matype" :key="item.value"  >
                {{item.label}}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-item>
          <a-form-item v-if="nodeType.indexOf('1')>-1" label="企业标识码(MA)" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input :disabled="isDetail" placeholder="请输入企业标识码(MA)" v-decorator.trim="['rootNode', validatorRules.rootNode]" />
          </a-form-item>
          <a-form-item v-if="nodeType.indexOf('2')>-1" label="企业标识码(GS1)" :labelCol="labelCol" :wrapperCol="wrapperCol" >
            <a-input :disabled="isDetail" placeholder="请输入企业标识码(GS1)" v-decorator.trim="['gs1RootNode', validatorRules.gs1RootNode]" />
          </a-form-item>

          <a-form-item label="按钮" :labelCol="labelCol" :wrapperCol="wrapperCol" class="displayLabel" style="margin-right: 40%">
            <a-button v-show="!isDetail" type="primary" @click="submitTo">保存</a-button>
            <a-button v-show="isDetail" type="primary" @click="()=>{isDetail = false}">编辑</a-button>
          </a-form-item>
        </a-form>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { getCurrentInfo, putCompany } from '@/api/api.js'
import pick from 'lodash.pick'
export default {
  data () {
    return {
      isDetail:true,
      nodeType:[],
      matype: [
        {
          label: 'MA码(IDcode)',
          value: '1',
        },
        {
          label: 'GS1',
          value: '2',
        }
      ],
      form: this.$form.createForm(this),
      validatorRules: {
        nodeType:{
          rules: [
            {
              required: true,
              message: '请选择企业标识码码制!',
            },
          ],
        },
        companyName: {
          rules: [
            {
              required: true,
              message: '请输入公司名称!',
            },
          ],
        },
        companyFax: {
          rules: [
            {
              required: true,
              message: '请输入统一社会信息用代码!',
            },
          ],
        },
        companyAddress: {
          rules: [
            {
              required: true,
              message: '请输入联系地址!',
            },
          ],
        },
        socialCode: {
          rules: [
            {
              required: true,
              message: '请输入统一社会信息用代码!',
            },
          ],
        },
        rootNode:{
          rules: [
            {
              required: true,
              message: '请输入企业标识码!',
            },
          ],
        },
        gs1RootNode:{
          rules: [
            {
              required: true,
              message: '请输入企业标识码!',
            },
          ],
        },
        companyTel: {
          rules: [
            {
              required: true,
              message: '请输入联系电话!',
            },
          ],
        },
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      cardStyle: {},
      visible: false,
      model: {}
    }
  },
  created () {
    this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px'
    this.getData()
  },
  methods: {
    onColChange(val){
      this.nodeType = val
    },
    getData () {
      this.visible = true
      getCurrentInfo().then(res => {
        this.visible = false
        this.model = Object.assign({}, res.data),
          this.nodeType = this.model.nodeType?this.model.nodeType:[]

          this.$nextTick(()=>{
            this.form.setFieldsValue(
              pick(
                this.model,
                'socialCode',
                'companyTel',
                'companyContacts',
                'companyAddress',
                'companyFax',
                'companyName',
                'nodeType',
                'rootNode',
                'gs1RootNode'
              )
            )
          })

      })
    },
    submitTo () {
      console.log('===>>>',this.form)
      this.visible = true
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = Object.assign(this.model, values)
          putCompany(formData).then(res => {
            this.$message.success('修改成功')
            this.isDetail = true
            this.visible = false
          })
        }
      })
    }
  },
}
</script>
<style scoped >
.displayLabel>>>.ant-form-item-label label {
  display: none !important;
}

@import '~@assets/less/common.less'
</style>
<style>
#company .ant-form-item{
  width: 40%;
  float: left;
}
#company .title-info{
  width: 100%;
  margin-left: 30px;
  font-size: 20px;
  clear: both;
  margin-bottom: 15px;
}
</style>